import React from 'react'
import { Box, Grid, Typography, Card, decomposeColor, } from '@mui/material'
import TitleBar from 'components/TitleBar'
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";




const colorPalette = ["#3B00ED", "#9C27B0", "#D81B60", "#FF9800"];

const EnviromentReorting = ({ data, months, grouped }) => {

    const monthOrder = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  


    const incidentMonthlyData = [
        { name: "Trees planted", label: "No. of Tree planted (Sapling)", value: data?.environment?.treesPlanted || 0 },
        { name: "Water Consumed for drinking & construction ", label: "Total water consumed for drinking and construction purposes", value: data?.environment?.waterConsumedForConstructionDrinking || 0 },
        { name: "Diesel Consumption Of DG", label: "Total Diesel Consumption of DG", value: data?.environment?.dieselConsumptionOfDG || 0 },
        { name: "Diesel Consumptionn Of Site Utlity", label: "Total Diesel Consumption of site utlity vehicle", value: data?.environment?.dieselConsumptionOfSiteUtlity || 0 },
        { name: "Hazardous waste generated", label: "Total hazardous waste generated", value: data?.environment?.hazardousWaste["generated"] || 0 },
        { name: "Oil waste generated", label: "Total Oil waste generated", value: data?.environment?.oilWaste["generated"] || 0 },
        { name: "Oil waste Disposed", label: "Total Oil waste Disposed", value: data?.environment?.oilWaste["disposed"] || 0 },
        { name: "Non hazardous waste generated", label: "Total Non hazardous waste generated", value: data?.environment?.nonHazardousWaste["generated"] || 0 },
        { name: "Non hazardous waste Disposed", label: "Total Non hazardous waste Disposed", value: data?.environment?.nonHazardousWaste["disposed"] || 0 },
        { name: "Plastic waste generated", label: "Total Plastic waste generated", value: data?.environment?.plasticWaste["generated"] || 0 },
        { name: "Plastic waste Disposed", label: "Total Plastic waste Disposed", value: data?.environment?.plasticWaste["disposed"] || 0 },
        { name: "E-waste generated", label: "Total E-waste generated", value: data?.environment?.eWaste["generated"] || 0 },
        { name: "E-waste Disposed", label: "Total E-waste Disposed", value: data?.environment?.eWaste["disposed"] || 0 }
    ]

    const mainSeriesData = incidentMonthlyData.map((incident) => {

        return {
            name: incident.name,
            y: incident.value,
            drilldown: incident.name
        };

    });




    const drilldownSeries = incidentMonthlyData.map((incident) => {
        const monthlyData = grouped?.["Environment Reporting"]?.[incident.label] || {};
        const sortedKeys = Object.keys(monthlyData).sort((a, b) => {
            const [monthA, yearA] = a.split(" ");
            const [monthB, yearB] = b.split(" ");

            if (yearA !== yearB) {
                return Number(yearA) - Number(yearB);
            }

            return monthOrder.indexOf(monthA) - monthOrder.indexOf(monthB);
        });


        return {
            name: incident.name,
            id: incident.name,
            data: sortedKeys.map((key) => {
                return [key, monthlyData[key] || 0];
            })
        };
    });





    const total = incidentMonthlyData.reduce((sum, item) => sum + item.value, 0)

    const options = {

        chart: {
            type: 'column',
            scrollablePlotArea: {
                minWidth: 1200,
                scrollPositionX: 0
            }
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ""
        },
        accessibility: {
            announceNewData: {
                enabled: true
            }
        },
        colors: ['#C0CA33'],
        xAxis: {
            type: 'category',
            labels: {
                style: {
                    color: "#6B7280",
                    textOutline: 'none',
                    fontSize: "12px",
                    fontWeight: 600,
                }
            }

        },
        yAxis: {
            title: {
                text: 'Total Value of Environment Reporting  ',
                style: {
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#182A4E",
                    fontFamily: "Outfit, sans-serif",
                }
            }

        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            }
        },

        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat:
                '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
        },
        series: [
            {
                name: 'Environment Reporting',
                data: mainSeriesData
            }
        ],
        drilldown: {
            activeAxisLabelStyle: {
                color: "#6B7280",
                textDecoration: "none",
                fontWeight: 600,
            },
            activeDataLabelStyle: {
                color: "#6B7280",
                textDecoration: "none",
                fontWeight: 600,
            },
            breadcrumbs: {
                position: {
                    align: 'left'
                }
            },
            series: drilldownSeries
        },
        credits: {
            enabled: false
        }
    };

    return (
        <Card sx={{
            background: "#fff",
            borderRadius: 1,
            padding: 0,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            border: "1px solid #E4E4E4",
            height: "100%"
        }}>
            <Grid size={12}>
                <TitleBar title={"Environment Reporting"} description={""} />
            </Grid>


            {total === 0 ? (
                <Typography
                    sx={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#9CA3AF",
                        fontSize: "14px",
                        fontWeight: 500
                    }}
                >
                    No Data Available
                </Typography>
            ) : (
                <HighchartsReact highcharts={Highcharts} options={options} />
            )}

        </Card>
    )
}

export default EnviromentReorting
